import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeCanvas } from 'qrcode.react';

interface GenerateQRModalProps {
  open: boolean;
  closeModal: () => void;
  qrValue: string;
}

export function GenerateQRModal({ open, closeModal, qrValue }: GenerateQRModalProps) {
  if (!open) {
    return null;
  }
  const handleDownload = () => {
    const canvas = document.getElementById('qr-canvas') as HTMLCanvasElement;
    if (canvas) {
      const imageUrl = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = imageUrl;
      a.download = 'qr-code.png';
      a.click();
    } else {
      console.error('No se pudo encontrar el canvas');
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-80">
      {' '}
      <div className="bg-secondary-dark w-full max-w-md rounded-lg p-6 pt-1 shadow-lg">
        {' '}
        <h1 className="font-bold text-white">QR de Pacientes</h1>{' '}
        <p className="text-sm text-gray-400">
          {' '}
          Escanea el código QR para obtener los detalles del paciente.{' '}
        </p>{' '}
        <section className="mt-4 flex items-center justify-center">
          {' '}
          <QRCodeCanvas
            id="qr-canvas"
            value={qrValue}
            size={200}
          />{' '}
        </section>{' '}
        <div className="flex items-center justify-between">
          {' '}
          <button
            onClick={handleDownload}
            className="mt-4 flex gap-x-1 rounded bg-blue-700 px-4 py-2 text-white"
          >
            {' '}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              className="bi bi-arrow-down-square text-white"
              viewBox="0 0 16 16"
            >
              {' '}
              <path
                fillRule="evenodd"
                d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
              />{' '}
            </svg>{' '}
            Descargar QR{' '}
          </button>{' '}
          <button
            onClick={closeModal}
            className="mt-4 rounded bg-red-700 px-4 py-2 text-white"
          >
            {' '}
            Cerrar{' '}
          </button>{' '}
        </div>{' '}
      </div>{' '}
    </div>
  );
}
GenerateQRModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  qrValue: PropTypes.string.isRequired,
};
